export const instead = <T,>(value: T) =>
  `Instead got ${JSON.stringify(value)} (${typeof value})`;
